module.exports = __webpack_public_path__ + "img/measurement_info_left_hips_front.16d32df9.jpg";